import { Capacitor } from '@capacitor/core'
import { PushNotifications } from '@capacitor/push-notifications'
import { registerStaffDevice } from './staffChat.js'

const TOKEN_KEY = 'reverend_push_token'
const API = import.meta.env.VITE_API_URL || ''

export function getPushToken() {
  return localStorage.getItem(TOKEN_KEY) || null
}

// Persist the token locally and register it with the server, so notifications
// work independently of (and retroactively for) submitting a confession.
async function registerToken(token) {
  if (!token) return
  localStorage.setItem(TOKEN_KEY, token)
  try {
    await fetch(`${API}/api/push/register`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token }),
    })
  } catch (err) {
    console.warn('Failed to register push token with server:', err)
  }
  // Eingeloggte Seelsorger/Admin bekommen auf diesem Gerät Chat-Benachrichtigungen
  registerStaffDevice(token)
}

// Tapped notifications → listener in the app (jump to the confession).
// A tap that arrives before the app has subscribed (cold start) is buffered.
let openListener = null
let pendingOpen = null

export function onNotificationOpen(callback) {
  openListener = callback
  if (pendingOpen) {
    callback(pendingOpen)
    pendingOpen = null
  }
  return () => { if (openListener === callback) openListener = null }
}

export async function initPush() {
  if (!Capacitor.isNativePlatform()) return

  try {
    // Registered before requesting permissions, so a cold-start tap is not missed
    PushNotifications.addListener('pushNotificationActionPerformed', ({ notification }) => {
      const data = notification.data || {}
      if (data.type === 'chat') {
        const dashboard = data.dashboard === '/admin' ? '/admin' : '/pastor'
        window.location.href = `${dashboard}?chat=${encodeURIComponent(data.conversationId)}`
        return
      }
      const id = parseInt(data.confessionId)
      if (isNaN(id)) return
      const target = { id, type: data.type || 'karma' }
      if (openListener) openListener(target)
      else pendingOpen = target
    })

    const { receive } = await PushNotifications.requestPermissions()
    if (receive !== 'granted') return

    PushNotifications.addListener('registration', ({ value }) => {
      registerToken(value)
    })

    PushNotifications.addListener('registrationError', err => {
      console.error('Push registration failed:', err.error)
    })

    await PushNotifications.register()
  } catch (err) {
    // FCM not configured (missing google-services.json) or device unsupported
    console.warn('Push notifications unavailable:', err)
  }
}
